import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { goStep, nextStep, setPageComplete, submitForm, showToast } from "../store/qnbSlice";
import { stopOnError } from "./utils";
export function loadFormState(pageId, store) { var _state$qnb, _state$qnb$formState; var state = store.getState(); var formState = state === null || state === void 0 ? void 0 : (_state$qnb = state.qnb) === null || _state$qnb === void 0 ? void 0 : (_state$qnb$formState = _state$qnb.formState) === null || _state$qnb$formState === void 0 ? void 0 : _state$qnb$formState[pageId]; return formState; }
export function handleFormSubmit(pageId, store, language) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(val) {
            var _state$qnbProduct$loa;
            var state, pages, dispatch, submitFormResult, onFormSubmit, nextPage, stepResult, currentPage, toPage;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = store.getState();
                            pages = state.qnbProduct.productConfig.normalizedPages;
                            dispatch = store.dispatch;
                            _context.next = 5;
                            return dispatch(submitForm({ pageId: pageId, formState: val, language: language }));
                        case 5:
                            submitFormResult = _context.sent;
                            stopOnError(submitFormResult);
                            onFormSubmit = (_state$qnbProduct$loa = state.qnbProduct.loadedComponents.page[pageId]) === null || _state$qnbProduct$loa === void 0 ? void 0 : _state$qnbProduct$loa.onFormSubmit;
                            _context.next = 10;
                            return onFormSubmit === null || onFormSubmit === void 0 ? void 0 : onFormSubmit(val, store);
                        case 10:
                            nextPage = _context.sent;
                            if (nextPage) {
                                _context.next = 13;
                                break;
                            }
                            return _context.abrupt("return");
                        case 13:
                            stepResult = pageId;
                            if (!(nextPage === "next")) {
                                _context.next = 20;
                                break;
                            }
                            _context.next = 17;
                            return dispatch(nextStep({ fromAction: "pageSubmit" }));
                        case 17:
                            stepResult = _context.sent.payload;
                            _context.next = 23;
                            break;
                        case 20:
                            _context.next = 22;
                            return dispatch(goStep({ pageId: nextPage, fromAction: "pageSubmit", overrideNext: true }));
                        case 22: stepResult = _context.sent.payload.pageId;
                        case 23: // Check whether the sub-menu is changed after submit, show "Quote Saved" toast
                            currentPage = pages.find(function (p) { return p.pageId === pageId; });
                            toPage = pages.find(function (p) { return p.pageId === stepResult; });
                            if ((currentPage === null || currentPage === void 0 ? void 0 : currentPage.submenu) != null && ((currentPage === null || currentPage === void 0 ? void 0 : currentPage.submenu) != (toPage === null || toPage === void 0 ? void 0 : toPage.submenu) || (currentPage === null || currentPage === void 0 ? void 0 : currentPage.menu) != (toPage === null || toPage === void 0 ? void 0 : toPage.menu))) {
                                dispatch(showToast({ text: state.qnbProduct.quoteInfo.geQuoteMain.isPrefilled === "Y" ? "autoFilled" : "quoteSaved" }));
                            }
                            dispatch(setPageComplete(pageId));
                        case 27:
                        case "end": return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function (_x) { return _ref.apply(this, arguments); };
    }();
}
export function prefillValidation(_x2, _x3) { return _prefillValidation.apply(this, arguments); }
function _prefillValidation() { _prefillValidation = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(page, store) { var _pageConfig$inputId; var state, form, pageConfig, pageComponent, inputs, _pageComponent$pageVa, _pageComponent$pageVa2, validateResult; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            state = store.getState();
            form = state.qnb.formState[page];
            pageConfig = state.qnbProduct.productConfig.normalizedPages.find(function (p) { return p.pageId === page; });
            pageComponent = state.qnbProduct.loadedComponents.page[page];
            if (page) {
                _context3.next = 6;
                break;
            }
            return _context3.abrupt("return", false);
        case 6:
            inputs = pageConfig === null || pageConfig === void 0 ? void 0 : (_pageConfig$inputId = pageConfig.inputId) === null || _pageConfig$inputId === void 0 ? void 0 : _pageConfig$inputId.map(function (inputId) { return { input: state.qnbProduct.loadedComponents.input[inputId], inputId: inputId }; }).filter(function (i) { return !!i; });
            if (!(!inputs || inputs.length == 0)) {
                _context3.next = 9;
                break;
            }
            return _context3.abrupt("return", true);
        case 9:
            _context3.prev = 9;
            _context3.next = 12;
            return Promise.all(inputs.map(/*#__PURE__*/ function () { var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(input) { var _input$input$validati, _input$input; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (_input$input$validati = (_input$input = input.input).validation) === null || _input$input$validati === void 0 ? void 0 : _input$input$validati.call(_input$input, form[input.inputId], true, form);
                    case 2: return _context2.abrupt("return", _context2.sent);
                    case 3:
                    case "end": return _context2.stop();
                }
            } }, _callee2); })); return function (_x4) { return _ref2.apply(this, arguments); }; }()));
        case 12:
            validateResult = _context3.sent;
            _context3.next = 15;
            return (_pageComponent$pageVa = pageComponent.pageValidation) === null || _pageComponent$pageVa === void 0 ? void 0 : (_pageComponent$pageVa2 = _pageComponent$pageVa.validate) === null || _pageComponent$pageVa2 === void 0 ? void 0 : _pageComponent$pageVa2.call(_pageComponent$pageVa, form);
        case 15: return _context3.abrupt("return", validateResult.every(function (e) { return e == null; }));
        case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](9);
            return _context3.abrupt("return", false);
        case 21:
        case "end": return _context3.stop();
    }
} }, _callee3, null, [[9, 18]]); })); return _prefillValidation.apply(this, arguments); }
export var handleDate = function handleDate(params) {
    if (params == null)
        return ""; // 将日期字符串转换为Date对象
    var date = new Date(params); // 提取年、月和日
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0"); // 组合成新的格式
    var newDateString = year + month + day;
    return newDateString;
};
